import { exampleCommands } from "./demo";

export const PRESENTATION_DURATION = 19;
const prompt = "ecocloud@workspace:~$ ";
const slice = (text: string, time: number, start: number, duration: number) =>
  text.slice(
    0,
    Math.floor(
      Math.max(0, Math.min(1, (time - start) / duration)) * text.length,
    ),
  );

/** Time-based frames make pausing freeze typing, output and the dock together. */
export function presentationAt(time: number) {
  const dock =
    time < 1.1
      ? 0
      : time < 1.3
        ? (time - 1.1) / 0.2
        : time < 17
          ? 1
          : time < 17.16
            ? 1 - (time - 17) / 0.16
            : 0;
  let transcript = "";
  if (time >= 2.5)
    transcript = prompt + slice(exampleCommands[0].command, time, 2.5, 1.7);
  if (time >= 4.6) transcript += "\n" + exampleCommands[0].output + "\n\n";
  if (time >= 7)
    transcript += prompt + slice(exampleCommands[1].command, time, 7, 2);
  if (time >= 9.4)
    transcript += "\n" + exampleCommands[1].output + "\n\n" + prompt;
  return {
    dock,
    transcript,
    phase:
      dock === 0
        ? "overview"
        : time < 2.5
          ? "starting"
          : time < 9.4
            ? "typing"
            : time < 17
              ? "result"
              : "closing",
  };
}
